import { ReactNode, useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { ActiveFilter, ActiveFiltersBar, Input, TableFilter, TableFilters } from 'app/components'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Adicionar"). */
  actions?: ReactNode
}

export const ProfissionalDeSaudeListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(
    () => (debouncedFilters.nome.trim() ? `nome~*${debouncedFilters.nome.trim()}*` : ''),
    [debouncedFilters]
  )

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  const activeFilters: ActiveFilter[] = filters.nome.trim()
    ? [
        {
          key: 'nome',
          label: 'Profissional',
          value: `“${filters.nome.trim()}”`,
          onRemove: () => setFilter('nome', ''),
        },
      ]
    : []

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'profissional encontrado' : 'profissionais encontrados'}`
          }
        />
      }
    >
      <TableFilter label='Profissional de saúde' wide>
        <Input
          placeholder='Digite o nome'
          value={filters.nome}
          onChange={(e) => setFilter('nome', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
